const vatValidationRegexMap: Record<string, RegExp> = {
  GB: /^(GB)?\d{9}$/,
  DK: /^(DK)?\d{8}$/,
  NO: /^(NO)?\d{9}MVA$/,
};

export const validFormat: Record<string, string> = {
  GB: 'GB123456789',
  DK: 'DK12345678',
  NO: 'NO123456789MVA',
};

export const validateVAT = (
  countryCode: string,
  vatNumber: string
): boolean => {
  const regex = vatValidationRegexMap[countryCode];
  if (!regex) {
    return true;
  }
  return regex.test(vatNumber);
};
